export const DEMO_TOURNAMENT_NAME = "Saturday Singles";
export const DEMO_CENTER_NAME = "Oak Lane Bowl";

const squadDate = "2026-11-08";
const squadTime = "09:00:00";

export const demoSignup = {
  id: "demo-signup-1",
  status: "approved",
  paymentStatus: "held",
  heldUntil: "2026-11-07T17:00:00.000Z",
  tournament: { id: "demo-tournament", name: DEMO_TOURNAMENT_NAME },
  tournamentEvents: {
    id: "demo-event",
    eventName: "Singles",
    eventFee: [{ amount: 45 }],
  },
  squad: {
    squadDate,
    squadTime,
    bowlingCenters: {
      centerName: DEMO_CENTER_NAME,
    },
  },
  signupBowlers: [{ name: "Jordan Hale", role: "primary" }],
};

export const demoCartLine = {
  id: "demo-signup-1",
  event: { id: "demo-event", eventName: "Singles", entryFee: 45 },
  advertisedCents: 4500,
  paymentStatus: "held",
  status: "approved",
  tournamentId: "demo-tournament",
};

const demoDirectorSquad = {
  id: "demo-squad-1",
  squadDate,
  squadTime,
};

const directorSignup = ({
  id,
  name,
  email,
  status,
  paymentStatus,
  heldUntil,
  waitlistPosition,
}) => ({
  id,
  status,
  paymentStatus,
  heldUntil: heldUntil || null,
  waitlistPosition: waitlistPosition || null,
  email,
  createdAt: "2026-10-12T15:00:00.000Z",
  tournamentEvents: {
    id: "demo-event",
    eventName: "Singles",
    eventFee: [{ amount: 45 }],
  },
  squads: demoDirectorSquad,
  signupBowlers: [{ name, role: "primary" }],
});

export const demoDirectorSignups = [
  directorSignup({
    id: "dash-1",
    name: "Jordan Hale",
    email: "jordan.hale@example.com",
    status: "approved",
    paymentStatus: "paid",
  }),
  directorSignup({
    id: "dash-2",
    name: "Riley Chen",
    email: "riley.chen@example.com",
    status: "approved",
    paymentStatus: "walk_up",
  }),
  directorSignup({
    id: "dash-3",
    name: "Morgan Ellis",
    email: "morgan.ellis@example.com",
    status: "held",
    paymentStatus: "held",
    heldUntil: "2026-11-07T17:00:00.000Z",
  }),
  directorSignup({
    id: "dash-4",
    name: "Casey Brooks",
    email: "casey.brooks@example.com",
    status: "approved",
    paymentStatus: "unpaid",
  }),
  directorSignup({
    id: "dash-5",
    name: "Avery Quinn",
    email: "avery.quinn@example.com",
    status: "waitlisted",
    paymentStatus: "unpaid",
    waitlistPosition: 1,
  }),
];

export const demoDirectorFilters = {
  status: "on_squad",
  event: "all",
  squad: "all",
};

export const demoDirectorOnSquad = demoDirectorSignups.filter(
  (signup) => signup.status !== "waitlisted"
);

const ticket = (id, name) => ({
  id,
  bowlerID: `b-${id}`,
  bowlerName: name,
  treeID: "demo-tree",
});

const pair = (slot, left, right, leftScore, rightScore) => ({
  slot,
  status: leftScore >= rightScore ? "left" : "right",
  left,
  right,
  leftScore,
  rightScore,
  advancers: leftScore >= rightScore ? [left] : [right],
  extra: [],
});

const names = [
  "Jordan Hale",
  "Riley Chen",
  "Morgan Ellis",
  "Casey Brooks",
  "Avery Quinn",
  "Sam Ortega",
  "Taylor Kim",
  "Drew Patel",
];

export const demoTickets = names.map((name, index) =>
  ticket(String(index + 1), name)
);

const [t1, t2, t3, t4, t5, t6, t7, t8] = demoTickets;

const r1 = [
  pair(0, t1, t2, 234, 201),
  pair(1, t3, t4, 188, 212),
  pair(2, t5, t6, 226, 193),
  pair(3, t7, t8, 179, 215),
];
const r2 = [pair(0, t1, t4, 221, 198), pair(1, t5, t8, 207, 189)];
const final = pair(0, t1, t5, 245, 218);

export const demoResolvedTree = {
  tree: { id: "demo-tree", treeNumber: 1, hasBye: false },
  round1: r1,
  round2: r2,
  final,
  first: t1,
  second: t5,
};

export const demoBowlers = demoTickets.map((row) => ({
  id: row.bowlerID,
  name: row.bowlerName,
}));

const scoreRow = (id, name, average, handicap, verified) => ({
  id,
  name,
  average,
  handicap,
  hasAverage: true,
  isVerified: verified,
});

export const demoScoringTeam = {
  id: "demo-team",
  teamName: "Lane 12",
  gamesPerEvent: 3,
  isVerified: false,
  squad: { squadDate, squadTime },
  bowlers: [
    scoreRow("b1", "Jordan Hale", 198, 21, [213, 189, 246], true),
    scoreRow("b2", "Riley Chen", 176, 43, [168, 201, 154], true),
    scoreRow("b3", "Morgan Ellis", 162, 57, [147, 188, 171], false),
    scoreRow("b4", "Casey Brooks", 185, 34, [192, 175, 208], true),
  ],
  transformedScores: {
    b1: [{ score: 213 }, { score: 189 }, { score: 246 }],
    b2: [{ score: 168 }, { score: 201 }, { score: 154 }],
    b3: [{ score: 147 }, { score: 188 }, { score: 171 }],
    b4: [{ score: 192 }, { score: 175 }, { score: 208 }],
  },
};

const scratchFor = (id) =>
  demoScoringTeam.transformedScores[id].reduce((sum, game) => sum + game.score, 0);

export const demoCalculationResult = (teamId, entityId, type) => {
  if (teamId !== "demo-team") return null;
  if (entityId === "team") {
    const scratch = Object.keys(demoScoringTeam.transformedScores).reduce(
      (sum, id) => sum + scratchFor(id),
      0
    );
    const hdcp = demoScoringTeam.bowlers.reduce(
      (sum, bowler) => sum + scratchFor(bowler.id) + bowler.handicap * 3,
      0
    );
    return { teamScratchTotal: scratch, teamHandicapTotal: hdcp };
  }
  const bowler = demoScoringTeam.bowlers.find((row) => row.id === entityId);
  if (!bowler) return null;
  const scratch = scratchFor(entityId);
  if (type === "scratch") return { total: scratch };
  return { handicapTotal: scratch + bowler.handicap * 3 };
};

export const demoAverageBowlers = {
  bowlerData: [
    {
      bowlerId: "1",
      bowlerName: "Jordan Hale",
      average: 198,
      hasAverage: true,
      isVerified: true,
    },
    {
      bowlerId: "2",
      bowlerName: "Riley Chen",
      average: 176,
      hasAverage: true,
      isVerified: true,
    },
    {
      bowlerId: "3",
      bowlerName: "Morgan Ellis",
      average: 162,
      hasAverage: true,
      isVerified: false,
    },
    {
      bowlerId: "4",
      bowlerName: "Casey Brooks",
      average: 185,
      hasAverage: true,
      isVerified: false,
    },
    {
      bowlerId: "5",
      bowlerName: "Avery Quinn",
      average: 171,
      hasAverage: true,
      isVerified: false,
    },
  ],
};

const noop = () => {};

export const demoAverageHandlers = {
  editingBowlerId: null,
  editedAverage: "",
  editedHasAverage: true,
  errorMessage: "",
  verifyingBowlerId: null,
  verifyingAll: false,
  onEditClick: noop,
  onAverageChange: noop,
  onSaveClick: noop,
  onCancelClick: noop,
  onVerifyClick: noop,
  onHasAverageChange: noop,
  onUseCatalogAverage: noop,
  onReview: undefined,
  canVerifyBowlerForEdit: (id) => id === "3" || id === "4" || id === "5",
  canUnverifyBowlerForEdit: () => false,
  onSortChange: noop,
  sortBy: "lastName",
  sortOrder: "asc",
  emptyMessage: "No bowlers found.",
};
